export const imageExtensionsRegExp = new RegExp(/gif|jpg|jpeg|tiff|png/, "gi");
export const videoExtensionsRegExp = new RegExp("avi|flv|mpg|mp4|webm", "gi");
